//#region imports
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import fetchSubscribe from './utils/subscribe';

import 'assets/css/normalize.css';
import 'assets/css/font.styles.css';
import 'assets/css/base.styles.css';

import i18n from 'configs/locales';

import Main from 'views/Main';
import { CHECK_URL_LIST, SERVER_KEY_MAP } from 'configs/constants';
import Modals from 'views/Modals';
import { checkHEError, checkHESuccess, checkSubscribe } from 'utils/analytics';
import { TServerIds } from 'models/types';
//#endregion

const App = () => {

  const [request, setRequest] = useState<{ message: string; status: string; }>({ message: '', status: '' });
  const [hasVisibleModal, setModal] = useState<boolean>(false);
  const { t } = useTranslation();
  const toggleModal = () => setModal(!hasVisibleModal);
  const [operatorId, setOperatorId] = useState<TServerIds>('0');

  const location = useLocation();

  const searchQuery = new URLSearchParams(location.search);
  const lang = searchQuery?.get('lang') === 'kz' ? 'kz' : 'ru';

  const partId = searchQuery?.get('part_id') || searchQuery?.get('partid') || searchQuery?.get('partId');
  const clickId = searchQuery?.get('click_id') || searchQuery?.get('clickid') || searchQuery?.get('clickId') || '';

  const handlerSubscribe = useCallback(() => {
    if (SERVER_KEY_MAP[operatorId]?.url !== null) {
      checkSubscribe(operatorId);
      fetchSubscribe({
        success: () => {
          setRequest({ message: 'Success', status: 'ok' });
          setModal(true);
        },
        failure: () => {
          setRequest({ message: 'Failure', status: 'err' });
          setModal(true);
        },
        loading: () => {
          setRequest({ message: 'Loading', status: 'loading' });
        },
        clickId: clickId as string || '',
        partId: partId as string || '',
        operatorId
      });
    } else {
      setRequest({ message: 'Failure', status: 'err' });
      setModal(true);
    }
  }, [operatorId, partId, clickId]);

  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  useEffect(() => {
    document.title = t('common.title');
  }, []);

  useEffect(() => {
    const getData = async (tryNumber = 0) => {
      try {
        const result = await fetch(CHECK_URL_LIST[tryNumber].url, { method: 'GET' });
        const operatorId = result.headers.get('operator-id') as TServerIds ?? '0';
        if (operatorId !== '0') {
          setOperatorId(operatorId);
        } else {
          if (CHECK_URL_LIST.length - 1 > tryNumber) {
            getData(tryNumber + 1);
          }
        }
      } catch (e) {
        checkHEError(CHECK_URL_LIST[tryNumber]?.url)
        if (CHECK_URL_LIST.length - 1 > tryNumber) {
          getData(tryNumber + 1);
        }
      }
    };
    getData();
  }, []);

   useEffect(() => {
    if (operatorId !== '0') {
      checkHESuccess(operatorId);
    }
  }, [operatorId]);

  return (
    <>
      <Main onSubscribeClick={ handlerSubscribe } />
       <Modals
        request={ request }
        hasVisible={ hasVisibleModal }
        toggleModal={ toggleModal }
      />
    </>
  );
};

export default App;
